import createApi from 'api/createApi';

export const tags = {
	internalNotifications__sendArticles: 'mw/internal-notifications/send-articles',
	internalNotifications__knowledgeBaseUpdate: 'mw/internal-notifications/knowledge-base-update',
	internalNotifications__unreadCount: 'mw/internal-notifications/unread-count',
	internalNotifications__knowledgeBaseTree: 'mw/internal-notifications/knowledge-base/tree',
};

export const internalNotificationsApi = createApi({
	reducerPath: 'mw/internalNotificationsApi',

	endpoints: (builder) => ({
		sendArticles: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/internal-notifications/send-articles',
				body,
				jsonType: true,
			}),
			providesTags: [tags.internalNotifications__sendArticles],
		}),
		notifyKnowledgeBaseUpdate: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/internal-notifications/knowledge-base-update',
				body,
				jsonType: true,
			}),
			providesTags: [tags.internalNotifications__knowledgeBaseUpdate],
		}),
		unreadCount: builder.query({
			query: () => ({
				method: 'GET',
				url: '/mw/internal-notifications/unread-count',
			}),
			providesTags: [tags.internalNotifications__unreadCount],
		}),
		knowledgeBaseTree: builder.query({
			query: ({ query, isArticleSubscriptions } = {}) => {
				const params = new URLSearchParams();

				if (query) {
					params.set('query', query);
				}

				if (isArticleSubscriptions) {
					params.set('isArticleSubscriptions', '1');
				}

				const queryString = params.toString();

				return {
					method: 'GET',
					url: queryString
						? `/mw/internal-notifications/knowledge-base/tree?${queryString}`
						: '/mw/internal-notifications/knowledge-base/tree',
				};
			},
			providesTags: [tags.internalNotifications__knowledgeBaseTree],
		}),
		confirmKnowledgeBaseUpdate: builder.mutation({
			query: (notificationId) => ({
				method: 'POST',
				url: `/mw/internal-notifications/knowledge-base-update/${notificationId}/confirm`,
			}),
			invalidatesTags: [
				tags.internalNotifications__knowledgeBaseTree,
				tags.internalNotifications__unreadCount,
			],
		}),
		subscribe: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/internal-notifications/subscribe',
				body,
				jsonType: true,
			}),
			invalidatesTags: [tags.internalNotifications__knowledgeBaseTree],
		}),
		unsubscribe: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/internal-notifications/unsubscribe',
				body,
				jsonType: true,
			}),
			invalidatesTags: [tags.internalNotifications__knowledgeBaseTree],
		}),
	}),
});

export const {
	sendArticles,
	notifyKnowledgeBaseUpdate,
	unreadCount,
	knowledgeBaseTree,
	confirmKnowledgeBaseUpdate,
	subscribe,
	unsubscribe,
} = internalNotificationsApi.endpoints;

export default internalNotificationsApi;
